<template>
  <div class="container">
    <top-bar :value="keyword" :category="category"></top-bar>
    <div class="s-home-cart">
      <h4 class="s-title">
        {{category||'全部'}}
      </h4>
        <ul class="s-list" ref="list">
          <li v-for="(item,index) in list" :key="index">
            <router-link :to="{ name: 'infoDetail', params: { id: item.id }}" class="s-list-info">
              <div class="info">
                <div class="avator" v-lazy:background-image="item.selfy[item.selfyIndex]" ></div>
                <div>
                  <h5>{{item.douyinName}}</h5>
                  <p class="num">粉丝 {{numberFormat(item.douyinFansCount)}}</p>
                </div>
              </div>
              <button class="s-button s-button-primary">查看</button>
            </router-link>
          </li>
        </ul>
        <p v-show="isLoading" class="loading-msg">加载中...</p>
        <p v-show="allLoaded" class="loading-msg">我是有底线</p>
    </div>
  </div>
</template>

<script>
import config from '@/utils/config'
import utils from '@/utils/index'
import TopBar from '@/components/topBar'

export default {
  name: 'infoList',
  data() {
    const { keyword, category } = this.$route.query
    return {
      allLoaded: false,
      isLoading: false,
      pageSize: 10,
      page: 0,
      numberFormat: utils.numberFormat,
      list: [],
      keyword,
      category
    }
  },
  methods: {
    getInfo() {
      if (this.isLoading) {
        return
      }
      if (this.allLoaded) {
        return
      }

      this.isLoading = true
      this.$http
        .get(`${config.HOST}douyin/v1/kol/searchKol`, {
          params: {
            page: this.page,
            ...this.$route.query
          }
        })
        .then(
          response => {
            let data = response.body
            this.isLoading = false
            if (data.code === 0) {
              // this.list = data.data
              if (data.data.length) {
                this.list.push.apply(this.list, data.data)
              } else {
                this.allLoaded = true
              }

              this.page++
            } else {
            }
          },
          response => {
            this.isLoading = false
          }
        )
    }
  },
  mounted() {
    console.log(this.$route)
    this.getInfo()
    window.addEventListener('scroll', () => {
      if (this.$refs.list) {
        let rect = this.$refs.list.getBoundingClientRect()
        if (rect.bottom - 200 <= window.innerHeight) {
          this.getInfo()
        }
      }
    })
  },
  watch: {
    '$route.query'(val) {
      this.page = 0
      this.allLoaded = false
      this.list = []
      this.category = val.category
      this.getInfo()
    }
  },
  components: {
    'top-bar': TopBar
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../../components/button/button.less';
@import '../index.less';
.s-list {
}
.s-list-info {
  display: flex;
  color: #fff;
  font-size: 15px;
  justify-content: space-between;
  padding: 12px 15px;
  & > .info {
    display: flex;
    p {
      font-size: 12px;
      color: #9f9ea0;
    }
  }
  .avator {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    margin-right: 12px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .s-button {
    margin-top: 20px;
    min-width: 80px;
    height: 30px;
    line-height: 30px;
  }
}
.loading-msg {
  text-align: center;
  font-size: 12px;
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/containers/info/List.vue